// extracted by mini-css-extract-plugin
export default {"form-element__textfield":"TextBox_form-element__textfield__bIzCO"};